(() => {
  const ICONS = {
    price: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12.6 2.6a2 2 0 0 0-1.4-.6H4a2 2 0 0 0-2 2v7.2c0 .5.2 1 .6 1.4l8.8 8.8a2 2 0 0 0 2.8 0l7.2-7.2a2 2 0 0 0 0-2.8z"/><circle cx="7.5" cy="7.5" r="1.2" fill="currentColor" stroke="none"/></svg>',
    weight: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3v3M7 6h10l2 14H5L7 6z"/></svg>',
    height: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3v18M9 6l3-3 3 3M9 18l3 3 3-3"/></svg>',
    ruler: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="10" width="18" height="4" rx="1"/><path d="M7 10v4M11 10v4M15 10v4"/></svg>',
    diameter: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="8"/><path d="M4 12h16"/></svg>',
    link: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M9.5 14.5l5-5M8 16l-1.5 1.5a3.5 3.5 0 0 1-5-5L3 11M16 8l1.5-1.5a3.5 3.5 0 0 1 5 5L21 13"/></svg>',
    mount: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M8 3l8 8-8 8M3 3l4 4M3 21l4-4"/></svg>',
    legAngles: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5v6M12 11l-5 8M12 11l5 8"/></svg>',
    footprint: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M8 12h8"/><circle cx="5" cy="12" r="1.4" fill="currentColor" stroke="none"/><circle cx="19" cy="12" r="1.4" fill="currentColor" stroke="none"/></svg>',
    sections: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="4" width="14" height="4" rx="1"/><rect x="5" y="10" width="14" height="4" rx="1"/><rect x="5" y="16" width="14" height="4" rx="1"/></svg>',
    modular: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="10" width="4.5" height="4.5" rx="1"/><rect x="9.75" y="10" width="4.5" height="4.5" rx="1"/><rect x="16.5" y="10" width="4.5" height="4.5" rx="1"/></svg>',
    lock: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></svg>',
    // A tilted spirit-level rather than a clock face — reads clearly as "lean/tilt", not "time".
    cant: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><g transform="rotate(-14 12 12)"><rect x="4" y="9.5" width="16" height="5" rx="2.5"/><circle cx="13.6" cy="12" r="1.2" fill="currentColor" stroke="none"/></g></svg>',
    traverse: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12h18M7 8l-4 4 4 4M17 8l4 4-4 4"/></svg>',
    elevation: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M4 18a8 8 0 0 1 16 0"/><path d="M12 18V8M12 8l3 2M12 8l-3 2"/></svg>',
    stance: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="5" r="2.2"/><path d="M12 7.2v6M8 20l4-6.8L16 20M8.5 11h7"/></svg>',
    material: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="4" width="16" height="16" rx="2"/><path d="M4 9h16M9 4v16"/></svg>',
    caliber: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="8"/><circle cx="12" cy="12" r="3"/></svg>',
    environment: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M3 19l5.5-9L12 15l2.5-4L21 19H3z"/></svg>',
    custom: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2l2.6 6.6L21 11l-6.4 2.4L12 20l-2.6-6.6L3 11l6.4-2.4z"/></svg>'
  };

  // Read order, roughly: what it costs and weighs, what it fits, how it
  // adjusts mechanically, what scenario it suits, then build and capability
  // specs last. The Liquid side resolves all of this (Price straight from
  // Shopify, Attachment Type from its own metafield, the rest from the
  // Feature Chart fields), so this list only needs to match those exact
  // output keys, not the raw metafield headings.
  const FEATURE_META = [
    { key: "Weight",                     icon: "weight",    name: "Weight",                      benefit: "Lighter for long carries and stalks" },
    { key: "Height",                     icon: "height",    name: "Height",                      benefit: "Matches the setup to your shooting position and terrain" },
    { key: "Packed Length",              icon: "ruler",     name: "Packed Length",               benefit: "Fits in your pack or rifle case without extra bulk" },
    { key: "Packed Diameter Ø",          icon: "diameter",  name: "Packed Diameter",              benefit: "Slides into narrow pack pockets and pouches" },
    { key: "Attachment Type",            icon: "link",      name: "Attachment Type",             benefit: "Determines which other Spartan gear it's compatible with" },
    { key: "Mounting Options",           icon: "mount",     name: "Mounting Options",             benefit: "Confirms it'll actually attach to your rifle" },
    { key: "Leg Angles",                 icon: "legAngles", name: "Leg Angles",                  benefit: "Sets how far each leg swings, from tucked in to fully spread" },
    { key: "Footprint Spread",           icon: "footprint", name: "Footprint Spread",             benefit: "A wider footprint holds steadier once deployed" },
    { key: "Leg Sections",                icon: "sections",  name: "Leg Sections",                benefit: "More sections pack down smaller but add moving parts" },
    { key: "Modular Legs",               icon: "modular",   name: "Modular Legs",                benefit: "Swap or repair a single leg without replacing the whole unit" },
    { key: "Leg Lockout",                icon: "lock",      name: "Leg Lockout",                 benefit: "Keeps the legs deployed until you release the locking gate yourself" },
    { key: "Cant",                       icon: "cant",      name: "Cant",                        benefit: "Levels the rifle on uneven ground" },
    { key: "Traverse",                   icon: "traverse",  name: "Traverse",                    benefit: "How far you can swing onto target without repositioning" },
    { key: "Elevation/Depression",       icon: "elevation", name: "Elevation / Depression",      benefit: "Follow a target moving up or down a slope" },
    { key: "Optimal Shooting Position",  icon: "stance",    name: "Optimal Shooting Position",   benefit: "Shows at a glance whether it suits how you actually shoot" },
    { key: "Environment",                icon: "environment", name: "Environment",                benefit: "Shows which terrain, woodland, open plains, or mixed ground, it handles best" },
    { key: "Materials",                  icon: "material",  name: "Materials",                   benefit: "Determines the balance between weight and rigidity" },
    { key: "Caliber Rating",             icon: "caliber",   name: "Caliber Rating",              benefit: "The largest calibre it's rated to handle safely" }
  ];

  // Bipod and tripod products are judged on different criteria — Calibre and
  // Stock type only make sense for a rifle-mounted bipod.
  const GROUPS_BY_FAMILY = {
    Bipod: ["Position", "Calibre", "Stock type", "Target range", "Quarry", "Location", "Discipline"],
    Tripod: ["Position", "Target range", "Quarry", "Location", "Discipline"]
  };

  function initSection(root) {
    const sectionId = root.dataset.sectionId;
    const dataEl = document.getElementById("pcomp-data-" + sectionId);
    if (!dataEl) return;

    let products = {};
    try {
      products = JSON.parse(dataEl.textContent || "{}");
    } catch (err) {
      return;
    }

    const handles = Object.keys(products);
    if (handles.length < 2) return;

    // Row order comes from the section's blocks — merchants drag them to
    // reorder in the theme editor, this is just the order they left them in.
    // If no row blocks have been added at all (e.g. an existing section from
    // before this feature existed), default to showing every built-in row
    // in the standard order, rather than showing nothing.
    let rowOrder = [];
    try {
      rowOrder = JSON.parse(root.dataset.rowOrder || "[]");
    } catch (err) {
      rowOrder = [];
    }
    if (!rowOrder.length) {
      rowOrder = FEATURE_META.map((f) => ({ type: "builtin", key: f.key }));
    }
    const maxRows = parseInt(root.dataset.maxRows, 10) || 999;
    const viewMoreText = root.dataset.viewMoreText || "View more";
    const viewLessText = root.dataset.viewLessText || "View less";
    let rowsExpanded = false;
    let lastShowToggle = false;

    let current = { a: handles[0], b: handles[1] };
    let variant = {
      a: (products[handles[0]].variantLabels || [])[0] || "Standard",
      b: (products[handles[1]].variantLabels || [])[0] || "Standard"
    };
    let pickerSide = "a";

    const el = (id) => document.getElementById("pcomp-" + id + "-" + sectionId);
    const overlayEl = el("picker");

    // A product's specs are keyed by its own variant labels (e.g. Standard/Long,
    // or Mountain/Woodland) — never assume a name, always read from the product.
    function specsFor(product, side) {
      const sets = product.specs || {};
      const keys = Object.keys(sets);
      return sets[variant[side]] || sets[keys[0]] || {};
    }

    // Only true when this specific product has explicitly declared two real
    // variants (custom.comparison_variant_labels) — not just because some
    // stray data happens to sit in the second column.
    function hasVariant(product) {
      return Array.isArray(product.variantLabels) && product.variantLabels.length === 2;
    }

    // Names the specific criteria this product scores best on, rather than an averaged number.
    function keyHighlights(product) {
      const groups = GROUPS_BY_FAMILY[product.family] || GROUPS_BY_FAMILY.Bipod;
      const strong = [];
      const okay = [];
      groups.forEach((groupName) => {
        const rating = product.ratings[groupName];
        if (!rating) return;
        (rating.suited || []).forEach((name) => strong.push(name));
        (rating.workable || []).forEach((name) => okay.push(name));
      });
      const picks = strong.slice(0, 4);
      while (picks.length < 4 && okay.length) picks.push(okay.shift());
      return picks.map((name, i) => ({
        text: name,
        tier: i < strong.length ? "good" : "okay"
      }));
    }

    function render() {
      const productA = products[current.a];
      const productB = products[current.b];
      if (!productA || !productB) return;

      [["a", productA], ["b", productB]].forEach(([side, product]) => {
        el("name-" + side).textContent = product.name;
        // Star rating widget — instance ID 344184 is your site's compact
        // "bottomline" widget (stars + review count), not the full review
        // list. The product ID has to be the real one for each product,
        // since the picker swaps which product this is showing.
        el("yotpo-" + side).innerHTML = product.yotpoId
          ? '<div class="yotpo-widget-instance" data-yotpo-instance-id="344184" data-yotpo-product-id="' + product.yotpoId + '" data-yotpo-cart-product-id="" data-yotpo-section-id="product" data-yotpo-preloaded-data=""></div>'
          : "";
        el("spec-" + side).textContent = product.description || "";
        el("image-" + side).innerHTML = product.image
          ? '<img src="' + product.image + '" alt="' + product.name + '" loading="lazy">'
          : "";
        el("view-" + side).href = product.url || "#";

        const highlights = keyHighlights(product);
        el("tags-" + side).innerHTML = highlights
          .map((h) => '<div class="pcomp__tag ' + h.tier + '">' + h.text + "</div>")
          .join("");

        // Only show a toggle when this product has explicitly declared two
        // real variants — button text is whatever was typed in, not assumed.
        const variantEl = el("variant-" + side);
        if (hasVariant(product)) {
          variantEl.innerHTML = '<select class="pcomp__variant-select" data-side="' + side + '">' +
            product.variantLabels.map((label) => (
              '<option value="' + label + '"' + (variant[side] === label ? " selected" : "") + '>' + label + "</option>"
            )).join("") +
          "</select>";
        } else {
          variantEl.innerHTML = "";
        }
      });

      const labelSuffix = (product, side) => {
        const first = (product.variantLabels || [])[0];
        return first && variant[side] !== first ? " (" + variant[side] + ")" : "";
      };
      el("col-a").textContent = productA.name + labelSuffix(productA, "a");
      el("col-b").textContent = productB.name + labelSuffix(productB, "b");

      const specA = specsFor(productA, "a");
      const specB = specsFor(productB, "b");
      const customA = productA.customRows || {};
      const customB = productB.customRows || {};

      // A value can come from either the fixed spec set or a custom block —
      // custom rows aren't tied to a variant, they're fixed per product.
      function valueFor(key, side) {
        const specs = side === "a" ? specA : specB;
        const custom = side === "a" ? customA : customB;
        if (specs[key]) return specs[key];
        if (custom[key] && custom[key].value) return custom[key].value;
        return "";
      }

      const fixedByKey = new Map(FEATURE_META.map((f) => [f.key.toLowerCase(), f]));

      // Rows render strictly in the order the merchant left the blocks in —
      // no block for a row means it's skipped entirely, and a row with no
      // real data on either side is skipped too, even if a block exists.
      const rows = rowOrder
        .map((entry) => {
          if (entry.type === "builtin") {
            const f = fixedByKey.get(entry.key.toLowerCase());
            return f ? { key: f.key, icon: f.icon, name: f.name, benefit: f.benefit } : null;
          }
          if (entry.type === "custom") {
            return {
              key: entry.key,
              icon: "custom",
              name: entry.key,
              benefit: (customA[entry.key] && customA[entry.key].benefit) || (customB[entry.key] && customB[entry.key].benefit) || ""
            };
          }
          return null;
        })
        .filter(Boolean)
        .filter((f) => valueFor(f.key, "a") || valueFor(f.key, "b"));

      const showToggle = rows.length > maxRows;
      lastShowToggle = showToggle;

      el("frows").innerHTML = rows.map((f, i) => {
        const hidden = showToggle && i >= maxRows && !rowsExpanded;
        return (
          '<div class="pcomp__frow' + (hidden ? ' pcomp__frow--hidden' : '') + '" style="max-height:' + (hidden ? "0px" : "none") + '">' +
            '<div class="pcomp__frow-inner">' +
              '<div class="pcomp__feature"><span class="pcomp__feature-icon">' + ICONS[f.icon] + '</span><span class="pcomp__feature-name">' + f.name + "</span></div>" +
              '<div class="pcomp__fval">' + (valueFor(f.key, "a") || "—") + "</div>" +
              '<div class="pcomp__fval">' + (valueFor(f.key, "b") || "—") + "</div>" +
              '<div class="pcomp__benefit">' + f.benefit + "</div>" +
            "</div>" +
          "</div>"
        );
      }).join("");

      const toggleEl = el("toggle");
      toggleEl.innerHTML = showToggle
        ? '<button type="button" class="pcomp__toggle" data-action="toggle-rows">' +
            (rowsExpanded ? viewLessText : viewMoreText) +
          "</button>"
        : "";

      // Yotpo's SDK only scans the page once on initial load. Since these
      // widget divs get inserted dynamically whenever a product changes,
      // it has to be told explicitly to go find and initialize them. On a
      // slower mobile connection, Yotpo's own script may not have finished
      // loading yet on the very first render — checking once and giving up
      // is why it worked on desktop but silently failed on a real phone.
      // Retrying for a few seconds covers that instead of failing outright.
      initYotpoWhenReady();
    }

    function initYotpoWhenReady(attemptsLeft) {
      if (attemptsLeft === undefined) attemptsLeft = 12;
      if (window.yotpoWidgetsContainer && typeof window.yotpoWidgetsContainer.initWidgets === "function") {
        window.yotpoWidgetsContainer.initWidgets();
        return;
      }
      if (attemptsLeft > 0) {
        setTimeout(() => initYotpoWhenReady(attemptsLeft - 1), 400);
      }
    }

    // Toggling expand/collapse updates the existing row elements in place,
    // animating each one to its real measured height rather than trusting a
    // CSS-only transition — CSS Grid's "animate to fr" trick turned out to
    // be unreliable across real browsers when several rows toggle at once,
    // which showed up as a large blank gap instead of a smooth reveal.
    function applyRowExpansion() {
      const rowEls = el("frows").querySelectorAll(".pcomp__frow");
      rowEls.forEach((rowEl, i) => {
        const shouldHide = lastShowToggle && i >= maxRows && !rowsExpanded;
        const inner = rowEl.querySelector(".pcomp__frow-inner");
        const naturalHeight = inner ? inner.offsetHeight : 0;

        if (shouldHide) {
          // Snap to its current real height first, then animate down to 0 —
          // can't transition smoothly starting from "none".
          rowEl.style.maxHeight = naturalHeight + "px";
          // eslint-disable-next-line no-unused-expressions
          rowEl.offsetHeight; // force a reflow so the browser registers the starting height
          requestAnimationFrame(() => {
            rowEl.style.maxHeight = "0px";
            rowEl.classList.add("pcomp__frow--hidden");
          });
        } else {
          rowEl.classList.remove("pcomp__frow--hidden");
          rowEl.style.maxHeight = naturalHeight + "px";
          rowEl.addEventListener("transitionend", function onDone(event) {
            if (event.propertyName === "max-height") {
              rowEl.style.maxHeight = "none"; // let it breathe naturally afterwards
              rowEl.removeEventListener("transitionend", onDone);
            }
          });
        }
      });
      const toggleBtn = el("toggle").querySelector(".pcomp__toggle");
      if (toggleBtn) toggleBtn.textContent = rowsExpanded ? viewLessText : viewMoreText;
    }

    function openPicker(side) {
      pickerSide = side;
      const otherSide = side === "a" ? "b" : "a";
      const otherProduct = products[current[otherSide]];
      el("picker-title").textContent = otherProduct
        ? "Choose a product to compare with " + otherProduct.name
        : "Choose a product";
      el("picker-options").innerHTML = handles.map((handle) => {
        const product = products[handle];
        const isSelected = handle === current[side];
        const isOnOtherSide = handle === current[otherSide];
        const thumb = product.image
          ? '<img src="' + product.image + '" alt="" loading="lazy">'
          : "";
        const check = isSelected
          ? '<span class="pcomp__picker-check"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg></span>'
          : "";
        const classes = "pcomp__picker-option" + (isSelected ? " selected" : "") + (isOnOtherSide ? " pcomp__picker-option--disabled" : "");
        const disabledAttr = isOnOtherSide ? " disabled title=\"Already selected as the other product\"" : "";
        return (
          '<button type="button" class="' + classes + '" data-handle="' + handle + '"' + disabledAttr + '>' +
            check +
            '<span class="pcomp__picker-thumb">' + thumb + "</span>" +
            '<span class="pcomp__picker-option-name" title="' + product.name + '">' + product.name + "</span>" +
          "</button>"
        );
      }).join("");
      overlayEl.classList.add("open");
    }

    function closePicker() {
      overlayEl.classList.remove("open");
    }

    root.addEventListener("click", (event) => {
      const changeBtn = event.target.closest('[data-action="change"]');
      if (changeBtn) {
        openPicker(changeBtn.dataset.side);
        return;
      }
      const closeBtn = event.target.closest('[data-action="close-picker"]');
      if (closeBtn) {
        closePicker();
        return;
      }
      const option = event.target.closest(".pcomp__picker-option");
      if (option) {
        const handle = option.dataset.handle;
        current[pickerSide] = handle;
        variant[pickerSide] = (products[handle].variantLabels || [])[0] || "Standard";
        rowsExpanded = false;
        closePicker();
        render();
        return;
      }
      const toggleBtn = event.target.closest('[data-action="toggle-rows"]');
      if (toggleBtn) {
        rowsExpanded = !rowsExpanded;
        applyRowExpansion();
        return;
      }
      if (event.target === overlayEl) closePicker();
    });

    root.addEventListener("change", (event) => {
      const select = event.target.closest(".pcomp__variant-select");
      if (select) {
        variant[select.dataset.side] = select.value;
        render();
      }
    });

    render();
  }

  document.querySelectorAll(".pcomp").forEach(initSection);

  // Re-initialize when a merchant edits this section's settings in the theme editor.
  document.addEventListener("shopify:section:load", (event) => {
    const root = event.target.querySelector(".pcomp");
    if (root) initSection(root);
  });
})();